import React  from 'react';
import { Grid, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";

const EmptyCalendar = ({ text = "No se han encontrado datos", children, mt = 0 }) => {
    return (
            <Grid container mt={mt}>
                <Grid item xs={12} md={12} display={"flex"} justifyContent={"center"} mt={2}>
                    <img
                        src={`${process.env.REACT_APP_ROOT_SERVER_PATH}/static/images/empty-calendar.png`}
                        alt="empty-data"
                        width={214}
                        height={138}
                    />
                </Grid>

                <Grid item xs={12} md={12} display={"flex"} justifyContent={"center"} mt={2}>
                    <Typography variant="subtitle1" color={grey[500]}>
                        {children || text}
                    </Typography>
                </Grid>
            </Grid>

    )
}

export default EmptyCalendar;
